// import moment from "moment";

export const inputConstantProps = {
  TIME_FORMAT: 'hh:mm A',
  INFO: 'infoIcon',
};
export const defaultTimerStyle = {
  width: '100%',
  padding: '0.98rem 1rem',
  border: '1px solid #eaebef',
};
// export const defaultTorontoTime = moment.tz(moment(), "America/Toronto");
